import axios, { AxiosResponse } from 'axios';
import { v4 } from 'uuid';

export const maxFileSize = 50;
export function uploadFileOnS3(files, cb=(data)=>{}, error_cb=(data=null)=>{}) {
    const pdf_file = files[0];
    const id = v4();
    const collection_name = id;

    if(pdf_file.type !== 'application/pdf') {
        error_cb({
            msg: "Invalid File Type.<br>Accepted File Type: PDF"
        });
        return;
    }

    if((pdf_file.size / 1000000) > (maxFileSize)) {
        error_cb({
            msg: "File size exceed the limit. Please choose a file that is smaller than "+ maxFileSize +" MB and try again."
        });
        return;
    }

    const formData = new FormData();
    formData.append('collection_name', collection_name);
    formData.append('file', pdf_file);

    // const endpoint = '/api/convos/create';
    axios.post('/api/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    .then((response: AxiosResponse) => {
        if (response.data?.status === 1) {
            const conversationId = response.data?.conversationId;
            const collection_name = response.data?.collection_name;
            let i = 0;

            const checkStatus = () => {
                axios.post(`/api/convos/status`, {
                    conversationId,
                    collection_name
                }).then((resp)=>{
                    const { data } = resp;
                    if(data.success === 1 && (
                        data?.status === "in_progress" || data?.status === "completed"
                    )) {
                        cb(conversationId);
                    } else {
                        checkStatus();
                    }
                }).catch(()=>{
                });
            };
            checkStatus();
        } else if(response.data?.auth?.status === 'failed' || response.data?.auth?.status === 'invalid') {
            error_cb({
                showPopup: true
            });
        } 
    })
    .catch(() => {
        error_cb();
    });
};